export default "https://legacy.eskolare-development.com/images/orders-empty.png";